import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';

import { setPortal } from 'modules/portal';
import { addAllList } from 'modules/common';
import { cardList, getDashboardList, getScriptUserInfo } from 'lib/api/script';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import FunctionWrap from 'components/molecules/FunctionWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  box: { padding: 5, borderRadius: 4, color: '#fff' },
}));

const Dashboard = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { portal } = useSelector(({ portal }) => ({ portal: portal }));
  const dispatch = useDispatch();
  const { solution, handleClickSnackbar, handleLoading } = props;
  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };
  let initParams = {
    order: 'SCRIPT_CREATE_DATE',
    sort: 'desc',
    sDate: moment().startOf('week').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    allDay: 'all',
    adverId: '',
    manager: 'all',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [dashboardList, setDashboardList] = useState([]);
  const [copyText, setCopyText] = useState('');
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    getScriptUserInfo()
      .then((response) => {
        let newMember = [];
        for (let data of response.data.data) {
          newMember.push({
            HIWK_ID: data['SCRIPT_HIWK_ID'],
            USER_NAME: data['SCRIPT_USER_NAME'],
            USER_ID: data['SCRIPT_USER_ID'],
            TRELLO_ID: data['SCRIPT_TRELLO_ID'],
          });
        }
        newMember.push(
          { USER_ID: 'platform', USER_NAME: '플랫폼팀' },
          { USER_ID: 'insite', USER_NAME: '인사이트팀' },
          { USER_ID: 'enp_wjlee2', USER_NAME: '이원준' },
          { USER_ID: 'khchoi', USER_NAME: '최광훈' },
          { USER_ID: 'song2064', USER_NAME: '송민혁' },
          { USER_ID: 'dmsdud2356', USER_NAME: '백은영' }
        );
        setUserList(newMember);
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error.message,
          option: { type: 'error' },
        });
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!!dashboardList[0]) {
      setCopyText(
        '합계 : ' +
          dashboardList[0]['SCRIPT_RESULT'] +
          '건(문의 : ' +
          dashboardList[0]['SCRIPT_CONTACT'] +
          '건, 독립몰 : ' +
          dashboardList[0]['SCRIPT_SELF'] +
          '건, 솔루션 : ' +
          dashboardList[0]['SCRIPT_SOLUTION'] +
          '건, 스크립트 : ' +
          dashboardList[0]['SCRIPT_SCRIPT'] +
          '건, 인사이트 : ' +
          dashboardList[0]['SCRIPT_INSITE'] +
          '건)'
      );
    }
  }, [dashboardList]);

  const customized = {
    SCRIPT_SEQ: { merged: true },
    SCRIPT_STATE: {
      makeBody: (rowObj) => {
        return rowObj['SCRIPT_STATE'] === '02' ? (
          <div style={{ background: '#eb5a46' }} className={classes.box}>
            {t('긴급')}
          </div>
        ) : (
          '-'
        );
      },
    },
    SCRIPT_TYPE: {
      makeBody: (rowObj) => {
        const type = rowObj['SCRIPT_TYPE'];
        return type === '01' ? (
          <div style={{ background: '#f2d600' }} className={classes.box}>
            {t('스크립트')}
          </div>
        ) : type === '02' ? (
          <div style={{ background: '#ff9f1a' }} className={classes.box}>
            {t('인사이트')}
          </div>
        ) : type === '03' ? (
          <div
            style={{ background: 'linear-gradient(70deg, #f2d600, #ff9f1a)' }}
            className={classes.box}
          >
            {t('스크립트 + 인사이트')}
          </div>
        ) : (
          '-'
        );
      },
    },
    SCRIPT_TRELLO_LINK: {
      makeBody: (rowObj) => {
        return (
          <TableBtnWrap>
            {!!rowObj['SCRIPT_TRELLO_LINK'] && (
              <NewButton
                name="editCard"
                title={t('카드 링크')}
                iconBtn
                icon="faScroll"
                disableRipple
                onClick={(e) => handlePortalUrl(rowObj['SCRIPT_TRELLO_LINK'])}
              />
            )}
          </TableBtnWrap>
        );
      },
      bodyStyle: { width: 40 },
      orderFlag: false,
    },
    SCRIPT_SOLUTION: {
      makeBody: (rowObj) => {
        let newName = rowObj['SCRIPT_SOLUTION'];
        for (let value of solution) {
          if (value['CODE_ID'] === rowObj['SCRIPT_SOLUTION']) {
            newName = value['CODE_DESC'];
          }
        }
        return rowObj['SCRIPT_SOLUTION'] === '96' ? (
          <div style={{ background: '#f2d600' }} className={classes.box}>
            {newName}
          </div>
        ) : (
          newName
        );
      },
    },
    SCRIPT_MANAGER: {
      makeBody: (rowObj) => {
        let newName = rowObj['SCRIPT_MANAGER'];
        for (let user of userList) {
          if (user['USER_ID'] === rowObj['SCRIPT_MANAGER']) {
            newName = user['USER_NAME'];
            newName = newName + '(' + rowObj['SCRIPT_MANAGER'] + ')';
          }
        }
        return newName;
      },
    },
    SCRIPT_ADVER_ID: {
      makeBody: (rowObj) => {
        let result = rowObj['SCRIPT_ADVER_ID'];
        return !!result ? rowObj['SCRIPT_ADVER_ID'] : '-';
      },
    },
    SCRIPT_CREATE_DATE: {
      makeBody: (rowObj) => {
        let result = rowObj['SCRIPT_CREATE_DATE'];
        return !!result ? rowObj['SCRIPT_CREATE_DATE'] : '-';
      },
    },
    SCRIPT_CREATE_USER: {
      makeBody: (rowObj) => {
        let result = rowObj['SCRIPT_CREATE_USER'];
        return !!result ? rowObj['SCRIPT_CREATE_USER'] : '-';
      },
    },
    SCRIPT_UPDATE_DATE: {
      makeBody: (rowObj) => {
        let result = rowObj['SCRIPT_UPDATE_DATE'];
        return !!result ? rowObj['SCRIPT_UPDATE_DATE'] : '-';
      },
    },
    SCRIPT_UPDATE_USER: {
      makeBody: (rowObj) => {
        let result = rowObj['SCRIPT_UPDATE_USER'];
        return !!result ? rowObj['SCRIPT_UPDATE_USER'] : '-';
      },
    },
  };

  const getParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      if (name === 'allDay') {
        let tempParams = { ...newParams };
        if (newParams['allDay'] === '01') {
          delete tempParams['sDate'];
          delete tempParams['eDate'];
        } else {
          tempParams = {
            ...tempParams,
            sDate: initParams.sDate,
            eDate: initParams.eDate,
          };
        }
        setParams(tempParams);
      } else {
        setParams(newParams);
      }
    }
  };

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  const handleCopyText = () => {
    const copyText = document.getElementById('copyText');
    copyText.select();
    document.execCommand('copy');
  };

  return (
    <>
      <FunctionWrap loading={false}>
        <NewButton name="addName" onClick={handleCopyText}>
          {t('TEXT COPY')}
        </NewButton>
        <input
          type="text"
          id="copyText"
          value={copyText}
          style={{ position: 'fixed', top: -99, left: -99 }}
          readOnly
        />
      </FunctionWrap>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <FilterCollection
          label={t('전체기간')}
          name="allDay"
          params={params}
          value={params['allDay']}
          type="radio"
          list={[
            { label: t('해제'), value: 'all' },
            { label: t('사용'), value: '01' },
          ]}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDate={params['allDay'] !== '01'}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
        <NewInput
          type="filter"
          label={t('광고주ID')}
          name="adverId"
          params={params}
          value={params['adverId']}
          callBack={getParam}
        />
        <FilterCollection
          label={t('담당자')}
          name="manager"
          params={params}
          type="select"
          list={addAllList(userList, 'USER_NAME', 'USER_ID', 'all')}
          callBack={getParam}
          labelKey="USER_NAME"
          valueKey="USER_ID"
        />
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={getDashboardList}
        params={{ ...params, uri: '/script/dashboard' }}
        getParam={getParam}
        useTotal={false}
        useFetch={false}
        useToolBar={false}
        useStoreLoading={false}
        usePagenation={false}
        callBack={(state, data) => setDashboardList(data)}
      />
      <NewTableContainer
        dataReqPromise={cardList}
        params={{ ...params, uri: '/script/list' }}
        getParam={getParam}
        customized={customized}
        useTotal={false}
        useFetch={false}
        useExcel={false}
        useFullScreen={false}
        rowsPerPage={50}
        callBack={(state, data) => {
          if (!!state) handleLoading(false);
        }}
      />
    </>
  );
};

export default withRouter(Dashboard);
